import { render, staticRenderFns } from "./ExportModal.vue?vue&type=template&id=6bc86d6e&"
import script from "./ExportModal.vue?vue&type=script&lang=ts&"
export * from "./ExportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports